import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const SESSION_REPLAY_SAMPLE_RATE = 0.1;
const sessionSampledForReplay = Math.random() < SESSION_REPLAY_SAMPLE_RATE;

Sentry.init({
  dsn: 'https://2991eab0e25663b08767afe886601edf@o4507110525763584.ingest.us.sentry.io/4507368817754112',
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.5,
  tracePropagationTargets: ['localhost', /^https:\/\/.*\.mpactq\.com/],
  beforeSend(event, hint) {
    if (hint.originalException && typeof hint.originalException === 'object') {
      const exception = hint.originalException as { reported?: boolean };
      if (!exception.reported) {
        exception.reported = true;
        return null;
      }
    }
    return event;
  },
});

// Replay SDK is ~122 kB raw / ~25 kB transfer. Only download it for the
// SESSION_REPLAY_SAMPLE_RATE fraction of sessions that we'd actually record.
// The previous eager integration shipped Replay to 100% of users to record 10%.
if (sessionSampledForReplay) {
  Sentry.lazyLoadIntegration('replayIntegration')
    .then((replayIntegration) => {
      Sentry.addIntegration(
        replayIntegration({
          // Session is already sampled-in above, so record everything in this session.
          sessionSampleRate: 1.0,
          errorSampleRate: 1.0,
        }),
      );
    })
    .catch(() => { /* chunk failed to load; degrade silently — Sentry errors still fire */ });
}

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch((err) => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
